import React from 'react'

export interface IconProps {
  img: string
  text: React.ReactNode
}

export const Icon: React.FC<IconProps> = ({ img, text }) => {
  return (
    <span className='ch-icon ds-u-font-size--base'>
      <span className='ch-icon-img-wrapper'>
        <img src={img} alt='' />
      </span>
      {text && <span className='ch-icon-caption '>{text}</span>}
    </span>
  )
}
